import {Division} from "./Division";
import {
  combatWidthX,
  MY_UNITS_POSITION,
  myTroopsCount,
  myWidth,
  SIDES_ENEMY,
  SIDES_ME,
  TROOP_TYPE_INFANTRY
} from "./constants";
import {IMAGES} from "./Images";
import {Campaign} from "./Campaign";

const baseAIY = 0;
const centered = (width) => combatWidthX / 2 - width
const rightThird = Math.floor(combatWidthX * 2 / 3)



const spam = (size, startX, startY) => new Division(
  SIDES_ENEMY,
  myWidth, size,
  "სპარსელები", TROOP_TYPE_INFANTRY, "some persian asshole",
  10, 8,
  startX, startY
).attachImage(IMAGES.persians, IMAGES.persiansMin)


const aragvelian300 = new Campaign(
  [
    [
      new Division(
        SIDES_ME,
        myWidth, myTroopsCount,
        "ფშავლები", TROOP_TYPE_INFANTRY,"",/* "ფშაველი",*/
        15, 10,
        0, MY_UNITS_POSITION
      ).attachImage(IMAGES.pshavlebi, IMAGES.pshavlebiMin),
      new Division(
        SIDES_ME,
        myWidth, myTroopsCount,
        "ხევსურები", TROOP_TYPE_INFANTRY, "", /* "ხევსური",*/
        15, 10,
        myWidth + 2, MY_UNITS_POSITION
      ).attachImage(IMAGES.xevsurebi, IMAGES.xevsurebiMin),
      new Division(
        SIDES_ME,
        myWidth, myTroopsCount,
        "შავჩოხოსნები", TROOP_TYPE_INFANTRY, "",/* "aragveli",*/
        25, 10,
        2 * (myWidth + 2), MY_UNITS_POSITION
      ).attachImage(IMAGES.blackChokhars, IMAGES.blackChokharsMin)
    ]
  ],
  [
    [spam(10, centered(myWidth), baseAIY)],
    [spam(50, centered(myWidth), baseAIY)],
    [spam(50, 0, baseAIY), spam(50, centered(myWidth), baseAIY)],
    [spam(100, centered(myWidth), baseAIY)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth), baseAIY)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth), baseAIY)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
    [spam(100, 0, baseAIY), spam(100, centered(myWidth)), spam(100, rightThird)],
  ],
  '',
  {}
)

export const CAMPAIGNS = {
  aragvelian300
}